import { LegalClientBranchEntity, LegalClientEntity } from 'api/types/entity';
import { useLockLegalClient } from 'modules/client/legal/hooks/useLockLegalClient';

export const useLockLegalClientBranch = (
  legalClient: LegalClientEntity | null,
  branch: LegalClientBranchEntity | null
) => {
  const { lockClientIfPossible, unlockClient } = useLockLegalClient(
    legalClient
      ? {
          ...legalClient,
          versionNumber: branch?.versionNumber,
        }
      : null
  );

  return { lockClientIfPossible, unlockClient };
};
